import {AxiosInstance} from "axios"
import {responseHandler} from "./response"
import {ApiPayload} from "./types"
import {CheckoutInit, CheckoutSession, TransactionStatus} from "../../types/transaction"

/** Plans on sale, and the discount the account already has */
export const initPayment = async (client: AxiosInstance) =>
    responseHandler<ApiPayload<CheckoutInit>>(client.get("/transactions/init"))

/**
 * Opens an Ikeepay checkout for a plan.
 *
 * The amount is not sent: the API prices the plan itself, so a client cannot decide what it pays.
 */
export const createCheckout = async (client: AxiosInstance, tier: string) =>
    responseHandler<ApiPayload<CheckoutSession>>(client.post("/transactions/checkout", {tier}))

/** Where a payment stands, for a client whose socket never opened */
export const checkTransactionStatus = async (client: AxiosInstance, transactionId: string) =>
    responseHandler<ApiPayload<{ status: TransactionStatus }>>(client.get(`/transactions/sync/${transactionId}`))
